/**
 * El API histórico devolvía `trabajador` en GET /me mientras el resto del cliente usa `worker`.
 * Normalizamos aquí para rutas, layout y permisos.
 */
export function effectiveAppRole(rol) {
    if (rol === 'trabajador' || rol === 'operario') return 'worker';
    return rol;
}

export function isWorkerRole(rol) {
    return effectiveAppRole(rol) === 'worker';
}

export function isSupervisorRole(rol) {
    return effectiveAppRole(rol) === 'supervisor';
}

export function isSuperadminRole(rol) {
    return (rol ?? '') === 'superadmin';
}
